import { IconProp } from "@fortawesome/fontawesome-svg-core"
import clsx from "clsx"
import { useMemo } from "react"

import { faIcon } from "@utils/faIcon"

import { Skeleton } from "@particles/index"

import { Icon } from "@atoms"

import { useFormField } from "@molecules/Form/Form"

import styles from "./InputHelpText.module.scss"
import { InputHelpTextProps, InputHelpTextStatus } from "./InputHelpText.types"

export function BaseInputHelpText(props: InputHelpTextProps) {
    const { message, status, neutralIcon = null, isLoading = false, id, ...rest } = props

    const typeIcon = useMemo(() => {
        const typeMap: Record<InputHelpTextStatus, IconProp | null> = {
            neutral: neutralIcon,
            success: faIcon({ name: "circle-check", style: "solid" }),
            info: faIcon({ name: "circle-info", style: "solid" }),
            warning: faIcon({ name: "triangle-exclamation", style: "solid" }),
            error: faIcon({ name: "circle-xmark", style: "solid" }),
        }
        return typeMap[status]
    }, [status, neutralIcon])

    if (isLoading) {
        return (
            <div className={styles.skeleton}>
                <Skeleton width="100%" height={10} borderRadius={0} />
            </div>
        )
    } else {
        return (
            <div className={clsx(styles.base, styles[status])}>
                {typeIcon && <Icon container="fixedHeight" icon={typeIcon} className={styles.icon} size={14} />}
                <p id={id} className={styles.text} {...rest}>
                    {message}
                </p>
            </div>
        )
    }
}

export default function InputHelpText(props: InputHelpTextProps) {
    const { inFormField = true, ...baseProps } = props

    if (inFormField) {
        const { formMessageId } = useFormField()
        return <BaseInputHelpText {...baseProps} id={formMessageId} />
    } else {
        return <BaseInputHelpText {...baseProps} />
    }
}
